
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_ieaqn_145",
  "pad-bottom": "awsui_pad-bottom_15o6u_ieaqn_167",
  "has-background": "awsui_has-background_15o6u_ieaqn_174",
  "highlighted": "awsui_highlighted_15o6u_ieaqn_177",
  "selected": "awsui_selected_15o6u_ieaqn_177",
  "disabled": "awsui_disabled_15o6u_ieaqn_195",
  "next-item-selected": "awsui_next-item-selected_15o6u_ieaqn_205",
  "is-keyboard": "awsui_is-keyboard_15o6u_ieaqn_217",
  "parent": "awsui_parent_15o6u_ieaqn_221",
  "interactiveGroups": "awsui_interactiveGroups_15o6u_ieaqn_225",
  "child": "awsui_child_15o6u_ieaqn_241",
  "virtual": "awsui_virtual_15o6u_ieaqn_256",
  "measure-strut": "awsui_measure-strut_15o6u_ieaqn_267",
  "measure-strut-first": "awsui_measure-strut-first_15o6u_ieaqn_276",
  "screenreader-content": "awsui_screenreader-content_15o6u_ieaqn_280",
  "option-content": "awsui_option-content_15o6u_ieaqn_286"
};
  